import { Divider, List, Skeleton } from 'antd'
import { ScrollBar } from 'components/CommonStyles'
import Flex from 'components/Flex'
import {
  SelectInputDiv,
  StyledInput,
} from 'components/UIComponents/FormStyles/index'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import ShortlistIcon from '../../../../../../components/icons/DriveTableIcon/Shortlist'
import Debounce from '../../../../../../utils/Debounce'
import { StyledAvatar, StyledInfiniteScroll } from '../../../../Style/style'
import { SetRoleDiv } from '../../../Dashboard/style'
import { RuleContext } from '../../RulesCreationTable'
import {
  CollageDetailsFlex,
  CollageNameFlex,
  CollegeCity,
  CollegeNameDiv,
  RemoveTextDiv,
  SelectClgDiv,
} from './style'

const AutoApproveCompanyDrawer = () => {
  const {
    selectedRuleDrawer,
    getCorporateList,
    brandList,
    setBrandList,
    setState,
  } = useContext(RuleContext)

  const [corporateList, setCorporateList] = useState([])
  const [hasMore, setHasMore] = useState(true)
  const [currentPage, setCurrentPage] = useState(0)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const onCorpSelectChange = index => {
    const updatedList = [...corporateList]
    const selectedItem = updatedList[index]
    selectedItem.isSelected = !selectedItem.isSelected

    setBrandList(prevState => {
      let updatedBrandList

      if (selectedItem.isSelected) {
        const data = {
          corporateId: selectedItem.id,
          corporateName: selectedItem.name,
        }
        updatedBrandList = [...prevState, data]
      } else {
        updatedBrandList = prevState.filter(
          item => item.corporateId !== selectedItem.id
        )
      }

      setState(prevState => ({
        ...prevState,
        brands: {
          ...prevState.brands,
          // isEnabled: selectedItem?.isSelected || updatedBrandList.length > 0,
          brandsList: updatedBrandList,
        },
      }))

      return updatedBrandList
    })

    // Update the corporate list
    setCorporateList(updatedList)
  }

  const fetchCorporateList = async (
    action,
    pageNumber = currentPage,
    searchString = search
  ) => {
    try {
      const pageNo = action ? pageNumber + 1 : pageNumber // Increment page if `action` is true
      const response = await getCorporateList(setLoading, pageNo, searchString)
      if (response?.data?.message === 'Success') {
        const { data } = response.data
        let addedList = data?.list?.map(item => {
          const isSelected = brandList.some(
            brandItem => brandItem.corporateId === item.id
          )

          return {
            ...item,
            isSelected: isSelected,
          }
        })

        if (pageNo === 0) {
          setCorporateList(addedList || [])
        } else {
          setCorporateList(prevList => [...prevList, ...(addedList || [])])
        }
        data?.list?.length > 0 ? setHasMore(true) : setHasMore(false)
        if (action) setCurrentPage(prevPage => prevPage + 1)
      }
    } catch (error) {
      console.error('Error fetching corporate list:', error)
    }
  }

  useEffect(() => {
    fetchCorporateList(false, currentPage, '')
    setSearch('')
  }, [selectedRuleDrawer])

  const delayToFetchCorporateList = useCallback(
    Debounce((data, pageNo) => {
      fetchCorporateList(false, pageNo, data)
    }, 500),
    [brandList]
  )
  const handleSearchChange = ({ target }) => {
    setSearch(target.value)
    setCurrentPage(0)
    delayToFetchCorporateList(target.value, 0)
  }

  return (
    <>
      <SetRoleDiv style={{ marginBottom: '30px' }}>
        In this rule, the companies added here will have the compensation caps
        overridden.
      </SetRoleDiv>
      <SelectInputDiv width="100%" borderleft={true}>
        <StyledInput
          type="text"
          width="100%"
          placeholder="Search by Corporate name"
          onChange={handleSearchChange}
          value={search}
          background={'#FAFAFB'}
        />
      </SelectInputDiv>
      <ScrollBar>
        <StyledInfiniteScroll
          dataLength={corporateList.length}
          next={() => fetchCorporateList(true)}
          hasMore={hasMore}
          loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
          height={'65vh'}
          padding={'0px 20px'}
        >
          {corporateList?.map((data, index) => (
            <>
              <List.Item key={data.id + index}>
                <CollageDetailsFlex spaceBetween centerVertically>
                  <Flex alignCenter>
                    <StyledAvatar
                      isImage={data?.logo}
                      src={data?.logo || undefined}
                    >
                      {!data.logo && data.name?.charAt(0)?.toUpperCase()}
                    </StyledAvatar>

                    <CollageNameFlex>
                      <CollegeNameDiv
                        style={{
                          width: '300px',
                          overflow: 'hidden',
                          color: '#000',
                        }}
                      >
                        {data.name}
                      </CollegeNameDiv>
                      <CollegeCity>{data.sector}</CollegeCity>
                    </CollageNameFlex>
                  </Flex>
                  <SelectClgDiv onClick={() => onCorpSelectChange(index)}>
                    {data.isSelected ? (
                      <RemoveTextDiv>
                        <ShortlistIcon /> Remove
                      </RemoveTextDiv>
                    ) : (
                      <>Add</>
                    )}
                  </SelectClgDiv>
                </CollageDetailsFlex>
              </List.Item>
              <Divider
                style={{
                  margin: 0,
                }}
              />
            </>
          ))}
        </StyledInfiniteScroll>
      </ScrollBar>
    </>
  )
}

export default AutoApproveCompanyDrawer
